import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const PersonTypeContext = React.createContext({
    internalName: null,
});
const PersonTypeContextProvider = (props) => {
    return (_jsx(PersonTypeContext.Provider, { value: { internalName: props.internalName }, children: props.children }));
};
export default PersonTypeContextProvider;
const usePersonType = () => {
    return React.useContext(PersonTypeContext);
};
export const usePersonTypeInternalName = () => usePersonType().internalName;
